import React, { useContext } from 'react';
import { ElementConfigType } from '../store/type';
import { PageEditorStoreContext } from '../store/PageEditorStore';
import { MyComponentType } from '@/pages2/DetailedDescription/component-factory/component-types';
import { ComponentIdEnum } from '@/pages2/DetailedDescription/component-factory/ComponentIdEnum';
import { lazy } from 'ice';
import { ConfigHOC } from '../HOC';

type Props = ElementConfigType;

const ImgLinkComponent: MyComponentType<Props> = (props: Props) => {
  const pageEditorStore = useContext(PageEditorStoreContext);
  const { id, privateSchema, parentNodeIsBody } = props;

  return (
    <div id={id}>
      {privateSchema?.link?.trim().length != 0 && !pageEditorStore.isDevelopment ? (
        <a href={privateSchema?.link} target={privateSchema?.blank ? '_blank' : '_self'} rel="noreferrer">
          <img
            style={{ width: '100%', borderRadius: '5px' }}
            src={`${
              // eslint-disable-next-line max-len
              privateSchema?.src?.[0]?.mediaSrc ||
              props.config.src ||
              'https://cdn.resource.youniverse.cc/d2c-app/qOz9xj08c9KEVx92SdsHe.jpg?image_process=resize,w_800'
            }?image_process=resize,w_1200/quality,Q_80/format,webp`}
            alt={privateSchema?.src?.[0]?.alt}
          />
        </a>
      ) : (
        <img
          style={{ width: '100%', borderRadius: '5px' }}
          src={`${
            // eslint-disable-next-line max-len
            privateSchema?.src?.[0]?.mediaSrc ||
            props.config.src ||
            'https://cdn.resource.youniverse.cc/d2c-app/qOz9xj08c9KEVx92SdsHe.jpg?image_process=resize,w_800'
          }?image_process=resize,w_1200/quality,Q_80/format,webp`}
          alt={privateSchema?.src?.[0]?.alt}
        />
      )}
    </div>
  );
};

const ConfigForm = lazy(() => import('../components-with-definition/ImgLinkComponentDefinition'));

const computeStyle = (componentConfig: ElementConfigType) => {
  const { privateSchema, parentNodeIsBody } = componentConfig;
  return parentNodeIsBody
    ? {
        width: '100%',
        display: 'block',
        paddingTop: 16,
        height: privateSchema?.src?.[0]?.aspectRatio ? 0 : 'auto',
        marginBottom: 16,
      }
    : {
        width: '100%',
        display: 'block',
        height: privateSchema?.src?.[0]?.aspectRatio ? 0 : 'auto',
      };
};

ImgLinkComponent.definition = {
  id: ComponentIdEnum.IMG_LINK_COMPONENT,
  name: '图片链接组件',
  icon: 'https://cdn.resource.youniverse.cc/d2c-app/5QgsVqOsl1jsw3VGPcJfL.jpg',
  position: 9, // 显示顺序
  config: {
    text: '这是一个图片容器',
    src: 'https://cdn.resource.youniverse.cc/d2c-app/5QgsVqOsl1jsw3VGPcJfL.jpg',
  },
  privateSchema: {},
  computeStyle,
  category: 'media',
  configForm: ConfigHOC(ConfigForm),
};

export { ImgLinkComponent };
